/* Two Wheels Motos — Year / Make / Model finder */
(function () {
  var STORAGE_KEY = 'twm_ymm_fitment';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function fillSelect(el, options, placeholder) {
    if (!el) return;
    var keep = el.value;
    el.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = placeholder;
    el.appendChild(ph);
    options.forEach(function (opt) {
      var o = document.createElement('option');
      o.value = opt;
      o.textContent = opt;
      el.appendChild(o);
    });
    if (keep && options.indexOf(keep) >= 0) el.value = keep;
    else el.value = '';
  }

  function buildTagUrl(collection, year, make, model) {
    var tags = [];
    if (year) tags.push('Year:' + year);
    if (make) tags.push('Make:' + make);
    if (model) tags.push('Model:' + model);
    var base = (collection || '/collections/new-parts').replace(/\/+$/, '');
    if (!tags.length) return base;
    // Shopify collection tag AND filter (works with tagged products)
    return base + '/' + tags.map(encodeURIComponent).join('+');
  }

  function decodeSafe(s) {
    try { return decodeURIComponent(String(s || '').replace(/\+/g, ' ')); }
    catch (e) { return String(s || ''); }
  }

  /** Pull Year/Make/Model from path tags, query string, or sessionStorage. */
  function parseFitmentFromLocation() {
    var out = { year: '', make: '', model: '' };
    var path = decodeSafe(window.location.pathname || '');
    var search = window.location.search || '';

    function applyTagChunk(chunk) {
      if (!chunk) return;
      String(chunk).split('+').forEach(function (part) {
        var p = decodeSafe(part).trim();
        var m = p.match(/^(Year|Make|Model)\s*:\s*(.+)$/i);
        if (!m) return;
        var key = m[1].toLowerCase();
        var val = m[2].trim();
        if (key === 'year') out.year = val;
        else if (key === 'make') out.make = val;
        else if (key === 'model') out.model = val;
      });
    }

    // /collections/new-parts/Year:2009+Make:Yamaha+Model:R6
    var pathMatch = path.match(/\/collections\/[^/]+\/(.+)$/i);
    if (pathMatch) applyTagChunk(pathMatch[1]);

    // ?Year%3A2009+Make%3AYamaha+Model%3AR6  (tag blob as query)
    if ((!out.year || !out.make) && search.length > 1) {
      var raw = search.slice(1);
      if (/Year%3A|Year:|Make%3A|Make:/i.test(raw)) applyTagChunk(raw.split('&')[0]);
      try {
        var params = new URLSearchParams(search);
        if (params.get('year')) out.year = params.get('year');
        if (params.get('make')) out.make = params.get('make');
        if (params.get('model')) out.model = params.get('model');
        // Some themes put the whole tag string as a single key
        params.forEach(function (_v, k) {
          if (/^Year:/i.test(k) || /Make:/i.test(k) || /Model:/i.test(k)) applyTagChunk(k);
        });
      } catch (e) { /* ignore */ }
    }

    if (out.year || out.make || out.model) return out;

    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        var parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object') {
          out.year = parsed.year || '';
          out.make = parsed.make || '';
          out.model = parsed.model || '';
        }
      }
    } catch (e) { /* ignore */ }
    return out;
  }

  function saveFitment(year, make, model) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ year: year, make: make, model: model || '' }));
    } catch (e) { /* ignore */ }
  }

  function applySelection(yearEl, makeEl, modelEl, byYear, years, sel) {
    if (!sel || !sel.year || years.indexOf(sel.year) < 0) return false;
    yearEl.value = sel.year;
    var makes = Object.keys(byYear[sel.year] || {}).sort();
    fillSelect(makeEl, makes, 'Make');
    makeEl.disabled = !makes.length;
    if (!sel.make || makes.indexOf(sel.make) < 0) {
      fillSelect(modelEl, [], 'Model');
      modelEl.disabled = true;
      return true;
    }
    makeEl.value = sel.make;
    var models = (byYear[sel.year][sel.make] || []).slice().sort();
    fillSelect(modelEl, models, 'Model');
    modelEl.disabled = !models.length;
    if (sel.model && models.indexOf(sel.model) >= 0) modelEl.value = sel.model;
    return true;
  }

  function initRoot(root, data) {
    var yearEl = root.querySelector('[data-ymm-year]');
    var makeEl = root.querySelector('[data-ymm-make]');
    var modelEl = root.querySelector('[data-ymm-model]');
    var form = root.querySelector('[data-ymm-form]');
    var collection = (root.getAttribute('data-ymm-collection') || '/collections/new-parts').trim();
    var byYear = data.byYear || {};
    var years = data.years || Object.keys(byYear).sort(function (a, b) { return Number(b) - Number(a); });

    fillSelect(yearEl, years, 'Year');
    fillSelect(makeEl, [], 'Make');
    fillSelect(modelEl, [], 'Model');
    if (makeEl) makeEl.disabled = true;
    if (modelEl) modelEl.disabled = true;

    function onYear() {
      var y = yearEl.value;
      var makes = y && byYear[y] ? Object.keys(byYear[y]).sort() : [];
      fillSelect(makeEl, makes, 'Make');
      fillSelect(modelEl, [], 'Model');
      makeEl.disabled = !makes.length;
      modelEl.disabled = true;
      saveFitment(yearEl.value, makeEl.value, modelEl.value);
    }

    function onMake() {
      var y = yearEl.value;
      var m = makeEl.value;
      var models = y && m && byYear[y] && byYear[y][m] ? byYear[y][m].slice().sort() : [];
      fillSelect(modelEl, models, 'Model');
      modelEl.disabled = !models.length;
      saveFitment(yearEl.value, makeEl.value, modelEl.value);
    }

    function onModel() {
      saveFitment(yearEl.value, makeEl.value, modelEl.value);
    }

    yearEl.addEventListener('change', onYear);
    makeEl.addEventListener('change', onMake);
    modelEl.addEventListener('change', onModel);

    applySelection(yearEl, makeEl, modelEl, byYear, years, parseFitmentFromLocation());

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var year = yearEl.value;
        var make = makeEl.value;
        var model = modelEl.value;
        if (!year || !make) {
          yearEl.focus();
          return;
        }
        saveFitment(year, make, model);
        window.location.href = buildTagUrl(collection, year, make, model);
      });
    }
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-twm-ymm]');
    if (!roots.length) return;
    var url = (roots[0].getAttribute('data-ymm-data-url') || '').trim();
    if (!url) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        roots.forEach(function (root) { initRoot(root, data); });
      })
      .catch(function () {
        roots.forEach(function (root) {
          var err = root.querySelector('[data-ymm-error]');
          if (err) err.hidden = false;
        });
      });
  });
})();
